import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Sandbox18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.75 2.25H11V0.75H7V2.25H8.25V8H6C6.01222 8.42404 6.07706 8.84386 6.19228 9.25H2.09282L3.53637 5.75H6.75V4.25H3.36028C2.84168 4.24982 2.35182 4.60155 2.18551 5.0912C1.5909 6.53288 0.874506 7.97476 0.387581 9.45575C0.294556 9.73868 0.248113 10.0348 0.250059 10.3326V15.5C0.250059 16.1808 0.819225 16.75 1.50006 16.75H16.5001C17.1809 16.75 17.7501 16.1808 17.7501 15.5V10.3231C17.7523 10.0214 17.7091 9.70062 17.5955 9.41926L15.8403 5.07114C15.6616 4.59018 15.175 4.25084 14.6613 4.25H11.25V5.75H14.4968L15.9096 9.25L11.8077 9.25C11.9229 8.84386 11.9878 8.42404 12 8H9.75V2.25ZM16.2501 10.75L1.75004 10.75L1.75006 15.25H16.2501L16.2501 10.75Z'
      fill='currentColor'
    />
  </Svg>
);

Sandbox18.displayName = 'Sandbox18';
export default Sandbox18;
